import {EventEmitter, Injectable} from '@angular/core';
import {ElectronService} from 'ngx-electron';

/**
 * Default Angular injection
 */
@Injectable({
  providedIn: 'root'
})
export class UpdaterService {

  progressEvent: EventEmitter<number> = new EventEmitter<number>();
  progressChangeEvent: EventEmitter<number> = new EventEmitter<number>();

  checkedForUpdates = false;
  updateAvailable = false;
  percent = 0;

  hiddenUI = false;
  private flag = false;

  constructor(public electronService: ElectronService) {
    this.electronService = electronService;
    setInterval(() => {
      // This is used for refresh
      this.flag = !this.flag;
    }, 1000);
    this.progressChangeEvent.subscribe((value) => {
      this.percent = value;
      this.progressEvent.emit(value);
    });

    if (this.electronService.isElectronApp) {
      this.electronService.ipcRenderer.on('update-available', (event, data) => {
        this.checkedForUpdates = true;
        this.updateAvailable = true;
      });
      this.electronService.ipcRenderer.on('update-not-available', (event, data) => {
        this.checkedForUpdates = true;
        this.updateAvailable = false;
        this.hiddenUI = true;
        setTimeout(() => {
          this.hiddenUI = true;
        }, 600);
      });
      this.electronService.ipcRenderer.on('update-progress', (event, data) => {
        this.percent = data;
        if (this.percent > 99) {
          setTimeout(() => {
            this.hiddenUI = true;
          }, 600);
        }
        this.progressEvent.emit(this.percent);
      });
      this.electronService.ipcRenderer.on('build-info', (event, args) => {
        const {version, buildNumber} = args;
        const versionLastNumber = version.split('.').pop();
        const versionFirstNumber = version.split('.').shift();
        const versionMiddleNumber = version.split('.')[1];
        const versionLastNumberNumber = Number(versionLastNumber);
        const versionFirstNumberNumber = Number(versionFirstNumber);
        const versionMiddleNumberNumber = Number(versionMiddleNumber);
        if (versionFirstNumberNumber === 0 && versionMiddleNumberNumber <= 8 && versionLastNumberNumber <= 12) {
          // Make sure it's still working for old builds
          this.electronService.ipcRenderer.send('check-for-updates');
        } else {
          // On newer builds, we don't need to check for updates in angular
          this.checkedForUpdates = true;
          this.updateAvailable = false;
          this.hiddenUI = true;
        }
      });
      this.electronService.ipcRenderer.send('build-info');
    }
  }
}
